const intiState = {
    product:[],
    totalprice:0,
    isActive:false,
    ren:false,
};

export default intiState;